import {ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Product} from '@spartacus/core';
import {BehaviorSubject, Subscription} from 'rxjs';

import {AimoProductSearchPage} from '../../../../model/product.model';
import {AimoGTMProductAttributes, GTMCartType, GTMItemListId} from '../../../../service/gtm/aimo-gtm.model';
import {AimoGtmService} from '../../../../service/gtm/aimo-gtm.service';
import {AimoProductFacetService} from '../../../../service/product/aimo-product-facet.service';
import {AimoProductService} from '../../../../service/product/aimo-product.service';
import {AimoWebextendService} from '../../../../service/webextend/aimo-webextend.service';
import {AimoSpinnerService} from '../../../shared/spinner/aimo-spinner.service';
import {AimoProductListComponentService} from "../../../../service/product/aimo-product-list-component.service";

@Component({
    selector: 'aimo-product-scroll',
    templateUrl: './aimo-product-scroll.component.html',
    standalone: false
})
export class AimoProductScrollComponent implements OnInit, OnDestroy {
    subscription: Subscription = new Subscription();
    private model: AimoProductSearchPage;
    model$: BehaviorSubject<AimoProductSearchPage> = new BehaviorSubject<AimoProductSearchPage>(null);

    @ViewChild('fullSearchSpinnerDiv') spinnerDiv: ElementRef;

    constructor(
        private ref: ChangeDetectorRef,
        protected activatedRoute: ActivatedRoute,
        protected facetService: AimoProductFacetService,
        protected spinnerService: AimoSpinnerService,
        protected aimoWebextendService: AimoWebextendService,
        protected productService: AimoProductService,
        protected gtmService: AimoGtmService,
        protected productListComponentService: AimoProductListComponentService,
    ) {
    }

    ngOnInit(): void {
        this.subscription.add(
            this.facetService.facetClicked$.subscribe((clicked) => {
                if (clicked) {
                    this.spinnerService.showInnerSpinner(this.spinnerDiv);
                }
            }),
        );
    }

    @Input()
    set setModel(inputModel: AimoProductSearchPage) {
        if (
            !inputModel.pagination.resetSearch &&
            inputModel.pagination.currentPage > 0 &&
            this.model?.requestedDate === inputModel.requestedDate
        ) {
            this.model = {
                ...inputModel,
                products: this.model?.products?.concat(inputModel.products ?? []),
            };
        } else {
            this.model = inputModel;
        }
        this.ref.markForCheck();
        this.aimoWebextendService.createImpressionEventFromSearchPage(this.model as AimoProductSearchPage);
        let idx = 0;
        if (this.model.freeTextSearch?.length > 0) {
            this.productService.fireProductListViewGtmEvent(
                this.model.products?.map((p) => ({...p, gtmProductAttributes: this.createGtmAttributes(idx++, p)})),
                this.model.pagination.totalResults,
                this.model.freeTextSearch,
            );
        }
        this.model$.next(this.model);
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    isCategoryPage(): boolean {
        return (
            this.activatedRoute.snapshot.url.length > 1 &&
            (this.activatedRoute.snapshot.url[0].path === 'category' ||
                this.activatedRoute.snapshot.url[0].path === 'c')
        );
    }

    createGtmAttributes(idx: number, product: Product): AimoGTMProductAttributes {
        return {
            ...this.gtmService.createProductGtmAttributesBase(product, this.isCategoryPage()
                ? GTMItemListId.product_category_page
                : GTMItemListId.product_search_page
            ),
            index: idx,
            cart_type: GTMCartType.cart,
            category_code: this.getCategoryCode(),
            search_term: this.getSearchTerm(),
        } as AimoGTMProductAttributes;
    }

    private getCategoryCode(): string {
        if (!this.isCategoryPage()) {
            return null;
        }
        if (this.activatedRoute.snapshot.queryParams?.query) {
            const split = this.activatedRoute.snapshot.queryParams?.query.split(':');
            for (let i = 0; i < split.length; ++i) {
                if (split[i] === 'category') {
                    return split[i + 1];
                }
            }
        }
        return this.activatedRoute.snapshot.url[1].path;
    }

    private getSearchTerm(): string {
        if (this.isCategoryPage()) {
            return null;
        }
        if (this.activatedRoute.snapshot.params?.query) {
            return this.activatedRoute.snapshot.params?.query;
        }
        if (this.activatedRoute.snapshot.queryParams?.query) {
            return this.activatedRoute.snapshot.queryParams?.query.split(':')[0];
        }
        return null;
    }

    changeListingProducts(pageSize: number, pageNumber: number): void {
        this.productListComponentService.getPageItemsForPageSize(pageSize, pageNumber);
    }
}
